"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styleMerger = (style1, style2, setState) => {
    if (style1 && style2) {
        const mergedStyle = Object.assign(Object.assign({}, style1), style2);
        setState(mergedStyle);
    }
    else {
        return style1;
    }
};
exports.default = styleMerger;
